"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirtyPounderAbilityHandler = exports.ThirtyPounderActorAbilityFactory = exports.ThirtyPounderAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ThirtyPounderAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ThirtyPounder;
        this.__typeName = "ThirtyPounder";
    }
}
exports.ThirtyPounderAbilityArgs = ThirtyPounderAbilityArgs;
let ThirtyPounderActorAbilityFactory = class ThirtyPounderActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ThirtyPounder", "OneEnemies", 0);
    }
};
ThirtyPounderActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ThirtyPounder")
], ThirtyPounderActorAbilityFactory);
exports.ThirtyPounderActorAbilityFactory = ThirtyPounderActorAbilityFactory;
let ThirtyPounderAbilityHandler = class ThirtyPounderAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttacksWithDamage({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            projectiles: [
                {
                    targetId,
                    jitter: 0,
                    type: "CannonBall",
                    path: "arc",
                    damages: [
                        AbilityDamage_1.AbilityDamage.Power("Fire", 80),
                        AbilityDamage_1.AbilityDamage.Power("Physical", 80),
                    ],
                }
            ],
            sequence,
            onHit(sequence, attack, damages, projectile) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(projectile.targetId, "feet"), "CannonBallExplosion"));
            },
            onMiss(sequence, attack, projectile) {
                sequence.push(new core_1.InstantVfxStepArgs(LocationSelector_1.ActorVfxLocationSelector.Miss(projectile.targetId), "CannonBallExplosion"));
            },
        });
    }
};
ThirtyPounderAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ThirtyPounder)
], ThirtyPounderAbilityHandler);
exports.ThirtyPounderAbilityHandler = ThirtyPounderAbilityHandler;
